import Select from './select/ContractInputAgreementSelect';
import Text from './text/ContractInputAgreementText';
import Share from './shares/ContractInputAgreementShares';
import DefaultShare from './defaultShare/ContractInputAgreementDefaultShare'

export default { Text, Select, Share, DefaultShare };
